import React, { useContext, useState } from "react";
import { Box, Checkbox, Heading, HStack, Text, VStack } from "native-base";
import { Helmet } from "react-helmet-async";
import PhoneInput from "react-phone-number-input";
import es from "react-phone-number-input/locale/es.json";
import styles from "./styles.module.css";
import colors from "../../../constants/colors";
import Stepper from "../../../components/stepper";
import API, { source } from "../../../api";
import { StatusContext } from "../../../contexts";
import { useNavigate } from "react-router-dom";
import routes from "../../../routes";

function SignUpVendorPage() {
  const navigate = useNavigate();
  const status = useContext(StatusContext);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isRemember, setIsRemember] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onRegister = async () => {
    setIsLoading(true);
    try {
      if (password !== confirmPassword) {
        throw new Error("Contraseñas no coinciden");
      }
      await API().post("/auth/local/register", {
        username: email,
        email,
        password,
        firstName,
        lastName,
        phone,
        isVendor: true,
        source: source,
      });
      status.updateSuccessMessage(
        "¡Gracias por registrarte! Por favor, verifica tu cuenta a través del enlace que te enviamos por correo electrónico. ¡Bienvenido!",
      );
      navigate(routes.signInRole.replace(":role", "agency"));
    } catch (error) {
      status.updateErrorMessage(error);
    }
    setIsLoading(false);
  };

  return (
    <VStack paddingTop={50} alignItems="center">
      <Helmet>
        <title>Registro - Proveedor</title>
      </Helmet>
      <Heading color={colors.secondary} fontSize="2xl" textAlign="center">
        Registrarse como proveedor
      </Heading>
      <Stepper step={1} />
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          onRegister();
        }}>
        <VStack
          backgroundColor={colors.white}
          padding={10}
          borderRadius={5}
          space={5}>
          <Heading color={colors.secondary} fontSize="xl">
            Información de contacto
          </Heading>
          <HStack marginTop={5} space={5}>
            <label className={styles.input}>
              <Text>Nombre</Text>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
            <label className={styles.input}>
              <Text>Apellido</Text>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
          </HStack>
          <HStack space={5}>
            <label className={styles.input}>
              <Text>Número de teléfono</Text>
              <PhoneInput
                labels={es}
                defaultCountry="MX"
                disabled={isLoading}
                value={phone}
                onChange={setPhone}
                required
              />
            </label>
            <label className={styles.input}>
              <Text>Correo electrónico</Text>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
          </HStack>
          <HStack space={5}>
            <label className={styles.input}>
              <Text>Contraseña</Text>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
            <label className={styles.input}>
              <Text>Confirmar contraseña</Text>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
          </HStack>
          <Checkbox
            colorScheme="danger"
            value={isRemember}
            onChange={setIsRemember}>
            <Text color={colors.gray}>Recordar mis datos</Text>
          </Checkbox>
        </VStack>
        <button disabled={isLoading}>
          <Box
            backgroundColor={colors.primary}
            paddingX={20}
            paddingY={2}
            borderRadius="full">
            <Text color={colors.white}>Continuar</Text>
          </Box>
        </button>
      </form>
    </VStack>
  );
}

export default SignUpVendorPage;
